import * as yup from 'yup';

export const clientCreateStep1Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    name: yup
      .string()
      .required(t('create.errors.missing.name'))
      .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
    code: yup
      .string()
      .required(t('create.errors.missing.code'))
      .max(10, t('create.errors.inputTooLong', { maxLength: '10' })),
    fullName: yup
      .string()
      .required(t('create.errors.missing.fullName'))
      .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
    addressLine: yup
      .string()
      .nullable()
      .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
    postalCode: yup
      .string()
      .required(t('create.errors.missing.postalCode'))
      .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
    city: yup
      .string()
      .required(t('create.errors.missing.city'))
      .max(255, t('create.errors.inputTooLong', { maxLength: '255' })),
    phone: yup.string().nullable(),
  });
